import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const getPreference = async (email: string) => {
  try {
    const callParams = await getCallParams("POST", { email });
    const response = await makeCall(urls.getPreference, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updatePreference = async (preference: Preference) => {
  try {
    const callParams = await getCallParams("POST", preference);
    const response = await makeCall(urls.updatePreference, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export interface Preference {
  email: string;
  newPrefs: {
    ageFrom: number;
    ageTo: number;
    latitude: number;
    longitude: number;
    cityKmRange: number;
    city: string;
    sex: string;
  };
}

export const chatUserList = async (
  email: string,
  page: number,
  perPage: number,
  search: string,
) => {
  try {
    const callParams = await getCallParams("POST", {
      email,
      page,
      perPage,
      search,
    });
    const response = await makeCall(urls.chatUserList, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const matchUserList = async (
  email: string,
  page: number,
  perPage: number,
  search: string,
) => {
  try {
    const callParams = await getCallParams("POST", {
      email,
      page,
      perPage,
      search,
    });
    const response = await makeCall(urls.matchUserList, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const favouriteUserList = async (
  email: string,
  page: number,
  perPage: number,
  search: string,
) => {
  try {
    const callParams = await getCallParams("POST", {
      email,
      page,
      perPage,
      search,
    });
    const response = await makeCall(urls.favouriteUserList, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const makeFavouriteUserChat = async (
  userEmail: string,
  favouriteEmail: string,
) => {
  try {
    const callParams = await getCallParams("POST", {
      userEmail,
      favouriteEmail,
    });
    const response = await makeCall(urls.favouriteUserChat, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const removeFavouriteUserChat = async (
  userEmail: string,
  favouriteEmail: string,
) => {
  try {
    const callParams = await getCallParams("DELETE", {
      userEmail,
      favouriteEmail,
    });
    const response = await makeCall(urls.favouriteUserChat, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const compatibilityForUsers = async (
  userEmail: string,
  targetEmail: string,
) => {
  try {
    const callParams = await getCallParams("POST", { userEmail, targetEmail });
    const response = await makeCall(urls.compatibilityForUsers, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getDailyProfiles = async (email: string) => {
  try {
    const callParams = await getCallParams("POST", { email });
    const response = await makeCall(urls.dailyProfiles, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

